'use client'

import { useCallback, useContext } from 'react'

import { I18nContext } from './i18n-context'

type Interpolatable = string | number

export const useTranslation = () => {
  const ctx = useContext(I18nContext)

  if (!ctx) throw new Error('I18nContext not set')

  const { dictionary, locale } = ctx

  const t = useCallback(
    (key: string, fallback?: string, args?: Record<string, Interpolatable>): string => {
      let value = dictionary[key] ?? fallback ?? key

      if (args) {
        if (Array.isArray(args)) {
          value = value.replace(/\{(\d+)\}/g, (_: string, i: number) => String(args[i]))
        } else {
          value = value.replace(/\{\{(\w+)\}\}/g, (_: string, key: string) => {
            const v = args[key]
            return v != null ? String(v) : ''
          })
        }
      }

      return value
    },
    [dictionary]
  )

  return { t, locale }
}
